import React from 'react'

import initialize from 'Core/utils/initialize'

import App from './App'
import { AuthInstance } from './constants'
import { RootStore } from './stores'

import 'antd/dist/reset.css'
import 'index.scss'

import 'Core/common/DataReport/Validation/globalReportDataValidation'

initialize({
	AuthInstance,
	rootStore: new RootStore(),
	component: <App />
})

//trigering test 1
